export const types = {
	ERROR: "error",
	SUCCESS: "success",
	ALERT: "alert"
};

export const typesArray = [types.ERROR, types.SUCCESS, types.ALERT];
